// Navigation mutations
import types from '../../types';

export default {
  [types.OPEN_NAVIGATION]: (state) => {
    state.isOpen = true;
  },
  [types.CLOSE_NAVIGATION]: (state) => {
    state.isOpen = false;
  },
  [types.SET_ACTIVE_MENU]: (state, payload) => {
    state.activeMenuItem = payload;
  },
  [types.OPEN_LEFT_NAVIGATION]: (state) => {
    state.isLeftOpen = true;
  },
  [types.CLOSE_LEFT_NAVIGATION]: (state) => {
    state.isLeftOpen = false;
  },
  [types.SET_LEFT_ACTIVE_MENU]: (state, payload) => {
    state.activeLeftMenuItem = payload;
  },
};
